export function splitEvery<T>(groupSize: number, list: T[]) {
  let idx = 0
  const grouped: T[][] = []

  while (idx < list.length) {
    grouped.push(list.slice(idx, (idx += groupSize)))
  }

  return grouped
}
